module.exports = new __parcel__URL__("written.9ea1f18e.png").toString();